export default __webpack_public_path__ + "static/media/header image.7c4672fa.png";